import * as React from "react";
import { cs } from "../../core/classSet";
import { SearchIcon } from "../Icons/Icons";
import styles from "./SearchInput.module.css";

interface IProps {
  inputClassName?: string;
  searchQuery?: string;
  onChange: (ev: React.ChangeEvent<HTMLInputElement>) => any;
}

export default function SearchInput({ inputClassName, searchQuery, onChange }: IProps) {
  return (
    <div className={styles.root}>
      <div className={styles.icon}>
        <SearchIcon width={20} height={20} />
      </div>
      <input
        className={cs(styles.input, inputClassName)}
        placeholder="What are you looking for?"
        type="search"
        value={searchQuery}
        onChange={onChange}
      />
    </div>
  );
}
